//Modals
import { Reducer as modalRootReducer } from 'components/Modal'
import { connectRouter } from 'connected-react-router'

//Advertisers
import { Reducer as AdvertisersListReducer } from 'modules/Advertisers/List'
import { Reducer as ClientsReducer } from 'modules/Agency/Clients'

// Agency module
import { Reducer as AgencyCardReducer } from 'modules/Agency/AgencyCard'
import { Reducer as RequestsReducer } from 'modules/Agency/Requests'
import appReducer from 'modules/App/reducer'

import { Reducer as AuthReducer } from 'modules/Auth'

//AutoReplenish
import { Reducer as AutoReplenish } from 'modules/AutoReplenish'

//Payment profiles
import { Reducer as PaymentProfilesInvoicesReducer } from 'modules/Finance/PaymentProfiles/Invoices'
import { Reducer as PaymentProfilesReducer } from 'modules/Finance/PaymentProfiles/List'

// Wallets
import { Reducer as WalletsReducer } from 'modules/Finance/Wallets'

// Forms reducers
import { FormsReducers } from 'modules/Forms'

// Billing module
import { Reducer as BillingReducer } from 'modules/Forms/Billing'
import { Reducer as notificationsReducer } from 'modules/Notifications'
import { Reducer as PromisedPayment } from 'modules/Finance/PromisedPayment'

//Recommendations module
import { Reducer as RecommendationsAuditsReducer } from 'modules/Recommendations/Audits'
import { Reducer as BenchmarksReducer } from 'modules/Recommendations/Benchmarks'

import { Reducer as RecommendationsListReducer } from 'modules/Recommendations/CampaignsRecommendations/TypesList'
import { Reducer as RecommendationTypeReducer } from 'modules/Recommendations/CampaignsRecommendations/Type'

// Referral module
import { Reducer as ReferralsList } from 'modules/Referral/List'
import { Reducer as ReferralsPayoutsListReducer } from 'modules/Referral/PayoutProfiles/Invoices'
import { Reducer as ReferralLinksReducer } from 'modules/Referral/ReferralLinks'
import { Reducer as ReferralClientsReducer } from 'modules/Referral/ReferralClients'

//Payout profiles
import { Reducer as PayoutProfilesReducer } from 'modules/Referral/PayoutProfiles/List'

// Services modules
import { Reducer as ServicesAccountAccess } from 'modules/Services/Access/List'
import { Reducer as ServicesAccount } from 'modules/Services/Account'
import { Reducer as AccountCreate } from 'modules/Services/AccountCreate'
import { Reducer as ServicesCampaigns } from 'modules/Services/Campaigns/Main'
import { Reducer as ServicesCampaign } from 'modules/Services/Campaigns/Start'
import { Reducer as ServicesNetwork } from 'modules/Services/Network'
import { Reducer as ServicesList } from 'modules/Services/NetworksList'

//Campaigns editor
import { Reducer as CampaignsEditor } from 'modules/Services/CampaignsEditor'
// import { Reducer as CampaignsEditor } from 'modules/Services/CampaignsEditor/Campaigns'
// import { Reducer as ServicesCampaignsEditorAdGroups } from 'modules/Services/CampaignsEditor/AdGroups'
// import { Reducer as ServicesCampaignsEditorBanners } from 'modules/Services/CampaignsEditor/Banners'
// Statistics module
import { Reducer as StatisticsAccountReducer } from 'modules/Statistics/Account'
import { Reducer as StatisticsAccountConnect } from 'modules/Statistics/AccountConnect'
import { Reducer as StatisticsCampaignReducer } from 'modules/Statistics/Campaign'
import { Reducer as StatisticsMainReducer } from 'modules/Statistics/Main'
import { Reducer as PulseReducer } from 'modules/Statistics/Pulse'
import StatisticsFiltersReducer from 'modules/Statistics/reducer'

// User module
import { Reducer as DoubleFAReducer } from 'modules/User/Security/2fa'
import { Reducer as UserAccountsConnectedReducer } from 'modules/User/Accounts'
import { Reducer as UserProfileReducer } from 'modules/User/Profile'
import { combineReducers } from 'redux'

//Tickets
import { Reducer as TicketsListReducer } from 'modules/Tickets/List'
import { Reducer as TicketReducer } from 'modules/Tickets/Ticket'

//PaymentOrder
import { Reducer as PaymentOrderReducer } from 'modules/Billing/PaymentOrder'

// Forms / Modals /Notifications components reducers
import { reducer as formReducer } from 'redux-form'
import { Reducer as BudgetEditor } from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor'

// Countries
import { Reducer as CountriesReducer } from 'modules/Countries'

// Stories
import { Reducer as StoriesReducer } from 'modules/Stories'

// Media Planner
import { Reducer as MediaPlannerReducer } from 'modules/MediaPlanner'

// Partners Program
import { Reducer as PartnersProgram } from 'modules/PartnersProgram'

//Accounts Marketplace
import { Reducer as AccountsMarketplaceListReducer } from 'modules/AccountsMarketplace/Categories'
import { Reducer as AccountsMarketplaceCategoryReducer } from 'modules/AccountsMarketplace/Category'
import { Reducer as AccountsMarketplaceProductsReducer } from 'modules/AccountsMarketplace/Products'
import { Reducer as AccountsMarketplaceProductReducer } from 'modules/AccountsMarketplace/Product'

const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    modal: modalRootReducer,
    auth: AuthReducer,
    notifications: notificationsReducer,
    form: formReducer,
    app: appReducer,
    ['accounts-marketplace/list']: AccountsMarketplaceListReducer,
    ['accounts-marketplace/category']: AccountsMarketplaceCategoryReducer,
    ['accounts-marketplace/products']: AccountsMarketplaceProductsReducer,
    ['accounts-marketplace/product']: AccountsMarketplaceProductReducer,
    ['statistics/filters']: StatisticsFiltersReducer,
    ['statistics']: StatisticsMainReducer,
    ['statistics/account']: StatisticsAccountReducer,
    //['statistics/account-manager']: StatisticsAccountManagerReducer,
    ['statistics/campaign']: StatisticsCampaignReducer,
    ['statistics/accountConnect']: StatisticsAccountConnect,
    ['statistics/pulse']: PulseReducer,
    agency: AgencyCardReducer,

    //Referral
    ['referral/list']: ReferralsList,
    ['referral/links']: ReferralLinksReducer,
    ['referral/clients']: ReferralClientsReducer,
    ['referral/payout-profiles']: PayoutProfilesReducer,
    ['referral/payouts-list']: ReferralsPayoutsListReducer,

    autoreplenish: AutoReplenish,
    //Services
    ['services/list']: ServicesList,
    ['services/network']: ServicesNetwork,
    ['services/network-account']: ServicesAccount,
    ['services/account-access']: ServicesAccountAccess,
    ['services/account-create']: AccountCreate,
    ['services/campaigns']: ServicesCampaigns,
    ['services/campaign']: ServicesCampaign,
    //Campaign editor
    ['services/campaigns-editor']: CampaignsEditor,
    ['services/budget-editor']: BudgetEditor,
    //Agency
    ['agency/clients']: ClientsReducer,
    ['agency/requests']: RequestsReducer,
    //User
    ['user/accounts']: UserAccountsConnectedReducer,
    ['user/profile']: UserProfileReducer,
    ['user/2fa']: DoubleFAReducer,
    //Advertisers
    ['advertisers-list']: AdvertisersListReducer,
    //Billing
    ['billing']: BillingReducer,
    //Finance
    ['finance/wallets']: WalletsReducer,
    ['finance/promised-payment']: PromisedPayment,
    ['finance/payment-profiles']: PaymentProfilesReducer,
    ['finance/payment-profiles-invoices']: PaymentProfilesInvoicesReducer,

    ['recommendations/audits']: RecommendationsAuditsReducer,
    ['recommendations/benchmarks']: BenchmarksReducer,
    ['recommendations/types']: RecommendationsListReducer,
    ['recommendations/type']: RecommendationTypeReducer,
    tickets: TicketsListReducer,
    ticket: TicketReducer,
    'payment-order': PaymentOrderReducer,
    'media-planner': MediaPlannerReducer,
    stories: StoriesReducer,
    countries: CountriesReducer,
    ['partners-program']: PartnersProgram,
    // Forms
    ...FormsReducers,
  })

export default rootReducer
